<!-- @format -->

<ng-container *transloco="let t">
  <div class="guidance-info">
    <sis-description-list [fillByColumn]="false">
      @if (completionMethod?.typeOfRequire === "ALL_SELECTED_REQUIRED") {
        <dl>
          <ng-template #listItem>
            <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.REQUIRE_RANGE_TITLE") }}</dt>
            <dd>{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.ALL_ASSESSMENT_ITEMS_REQUIRED") }}</dd>
          </ng-template>
        </dl>
      }
      @if (completionMethod?.typeOfRequire !== "ALL_SELECTED_REQUIRED") {
        <dl>
          @if (completionMethod?.typeOfRequire === "OPTIONAL_WITH_REQUIRE_RANGE") {
            <ng-template #listItem>
              <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.REQUIRE_RANGE_TITLE") }}</dt>
              <dd>{{ completionMethod?.require | intRange }}</dd>
            </ng-template>
          }
          @if (completionMethod?.assessmentItemOptionalityDescription) {
            <ng-template #listItem>
              <dt class="sis-label">{{ t("STUDIES.COURSE_UNIT_INFO_MODAL.OPTIONALITY_DESCRIPTION_TITLE") }}</dt>
              <dd>
                @if (useLocalizationFallback) {
                  <sis-localized-markup-string-view [content]="completionMethod.assessmentItemOptionalityDescription">
                  </sis-localized-markup-string-view>
                }
                @if (!useLocalizationFallback) {
                  <sis-course-unit-info-modal-text-field
                    [localizedMarkupStringValue]="completionMethod.assessmentItemOptionalityDescription"
                    [language]="language">
                  </sis-course-unit-info-modal-text-field>
                }
              </dd>
            </ng-template>
          }
        </dl>
      }
    </sis-description-list>
  </div>

  @if (completionMethod) {
    <div class="assessment-item-info">
      <sis-description-list [fillByColumn]="false">
        <dl>
          @if (completionMethod.description || showEmptyFields) {
            <ng-template #listItem>
              <dt class="sis-label">{{ t("STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.DESCRIPTION") }}</dt>
              <dd>
                @if (useLocalizationFallback) {
                  <sis-localized-markup-string-view [content]="completionMethod.description"> </sis-localized-markup-string-view>
                }
                @if (!useLocalizationFallback) {
                  <sis-course-unit-info-modal-text-field [localizedMarkupStringValue]="completionMethod.description" [language]="language">
                  </sis-course-unit-info-modal-text-field>
                }
              </dd>
            </ng-template>
          }
          @if (completionMethod.evaluationCriteria || showEmptyFields) {
            <ng-template #listItem>
              <dt class="sis-label">{{ t("STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.EVALUATION_CRITERIA") }}</dt>
              <dd>
                @if (useLocalizationFallback) {
                  <sis-localized-markup-string-view [content]="completionMethod.evaluationCriteria"> </sis-localized-markup-string-view>
                }
                @if (!useLocalizationFallback) {
                  <sis-course-unit-info-modal-text-field
                    [localizedMarkupStringValue]="completionMethod.evaluationCriteria"
                    [language]="language">
                  </sis-course-unit-info-modal-text-field>
                }
              </dd>
            </ng-template>
          }
          <ng-template #listItem>
            <dt class="sis-label">{{ t("STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.STUDY_PERIOD_REPEAT") }}</dt>
            <dd>
              <sis-completion-method-repeats [completionMethod]="completionMethod" [language]="language"></sis-completion-method-repeats>
            </dd>
          </ng-template>
        </dl>
      </sis-description-list>
    </div>
  }
</ng-container>
